import { LT_INCOMES_DATA_RECEIVED, LT_INCOME_UNLOADED, LT_INCOME_SAVED, LT_INCOME_DELETED } from './types';
import api from 'api';

export const incomeLTDataReceived = (data) => ({
  type: LT_INCOMES_DATA_RECEIVED,
  data
})

export const incomeLTDataUnload = () => ({
  type: LT_INCOME_UNLOADED
})

export const incomeSaved = data => ({
  type: LT_INCOME_SAVED,
  data,
})

export const incomeDeleted = data => ({
  type: LT_INCOME_DELETED,
  data,
})

export const unloadIncomes = () => dispatch => {
  dispatch(incomeLTDataUnload())
}

// TODO: catch with user logout and user data not recived
export const getIncomes = (view = false) => (dispatch) =>
  api.bmc.income.getIncomes(view?'viewTY':'').then( incomes => {
    dispatch(incomeLTDataReceived(incomes))
});

export const postIncome = (data) => (dispatch) =>
  api.bmc.income.postIncome(data).then( income => {
    dispatch(incomeSaved(income))
});

export const deleteIncome = (data) => (dispatch) =>
  api.bmc.income.deleteIncome(data).then( income => {
    dispatch(incomeDeleted(data))
});
